import { DividerProps } from '../../atoms/Divider';
import { TextProps } from '../../atoms/Text';
import { ThumbnailTextListProps } from '../../molecules/ThumbnailTextList';


type SportTeamsListBlockInternalProps = {
  text?: TextProps;
  divider?: DividerProps;
  thumbnailTextList?: ThumbnailTextListProps;
};

type SportTeamsListBlockPropsValues = {
  '': SportTeamsListBlockInternalProps;
};

const propValues: SportTeamsListBlockPropsValues = {
  '': {
    text: {
      type: 'Subheading',
      size: 'Medium',
      style: 'Regular',
      colour: 'SubduedDark',
      align: 'Left',
    },
    divider: {
      type: 'Horizontal',
      style: 'Thin',
      colour: 'DigitalGrey15',
    },
    thumbnailTextList: {
    },
  },
};

const getProps = (type: string): SportTeamsListBlockInternalProps => {
  const values: SportTeamsListBlockInternalProps = propValues[type];
  if (!values) {
    console.error(`${type} props not found`);
    return {};
  }
  return values;
};

export default getProps;
